import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/ArtistCoin.svg'

export const IconArtistCoin = IconSVG as IconComponent
